import { render, staticRenderFns } from "./UnsignedEmpty.vue?vue&type=template&id=8b932bd2"
import script from "./UnsignedEmpty.vue?vue&type=script&lang=js"
export * from "./UnsignedEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports